import '/assets/styles/partials/btn.scss';
import { Btn as RawBtn } from '@wearetla/tla-essentials-tools/partials/btn';
import { useMemo } from 'react';

// Context
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useApplication } from '/utilities/application';
import { useApplicationSupport } from '/utilities/application';

const Btn = ({ hollowLink, onClick, href, params, raw, target, ...props }) => {
	const { redirect, getRoutePath } = useNavigator();
	const { postMessage } = useApplication();
	const supportsExternalRedirects = useApplicationSupport('externalRedirects');

	const hollowProps = useMemo(() => {
		if (hollowLink) {
			return {
				onClick: (e) => {
					e?.stopPropagation?.();
					e?.preventDefault?.();

					const isExternal = href && href.startsWith('http');

					if(isExternal && supportsExternalRedirects) {
						const url = (() => {
							if(raw) { return href; }
							
							return getRoutePath(href, params);
						})();

						postMessage('openExternalUrl', url)
					}
					else {
						redirect(href, params, { raw, target });
					}

					if (onClick) {
						onClick(e);
					}
				},
			};
		} else {
			return {
				onClick,
				href,
				params,
				raw,
				target,
			};
		}
	}, [onClick, href, params, hollowLink, raw]);

	return <RawBtn {...props} {...hollowProps} />;
};

export default Btn;
